export class MainModel {

  constructor(){
    this.text='';
    
  }
  id: string;
  parentId: string;
  text: string;
  expanded: boolean;
  hasItems: boolean;
  items: MainModel[];
  icon: string;
  microApplicationId:any;
}
